export default {
  supplierProfile: {
    heading: '{name} book classes',
    supplierDescriptionTitle: 'Get to know {supplierName}',
    eventsFromTheSameSupplier: 'Book classes and events from {supplierName}',
    address: {
      title: '{name} address:',
    },
    relatedLinks: {
      city: '{name} offers classes in the following cities:',
      category: '{name} offers classes from these categories:',
    },
    articles: {
      sectionTitle: 'Magazine articles from {partnerName}',
    },
  },
}
